import Home from "./components/home";
import Offer from "./components/offer";
import Privacy from "./components/privacy-policy";
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import ProgrammPage from "./components/programm";
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    // Відстеження кліку на номер телефону
    document.addEventListener('click', (e) => {
      if (e.target.href && e.target.href.startsWith('tel:')) {
        const phone = e.target.href.replace('tel:', '');
        if (window.gtag) {
          window.gtag('event', 'phone_click', {
            'phone': phone,
            'event_category': 'engagement'
          });
        }
      }
    });

    // Відстеження кліку на email
    document.addEventListener('click', (e) => {
      if (e.target.href && e.target.href.startsWith('mailto:')) {
        const email = e.target.href.replace('mailto:', '');
        if (window.gtag) {
          window.gtag('event', 'email_click', {
            'email': email,
            'event_category': 'engagement'
          });
        }
      }
    });
  }, []);

  return (
    <div className="App">
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/programm" element={<ProgrammPage />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/offer" element={<Offer />} />
            </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
